import { IMask } from 'antd-mask-input';
export const PHONE_FORMAT = '(000) 000-0000';
export const PHONE_MASKED = IMask.createMask({
    mask: PHONE_FORMAT,
    pattern: PHONE_FORMAT,
});
